/**
 * A quiet divider between sections: a hairline of light with a single
 * accent glint at its center. Drop between any two sections in
 * HomePage.tsx (or any page) instead of letting them hard-cut.
 */
export function SectionVeil() {
  return <div className="veil" aria-hidden="true"></div>;
}
